/* ==========================================================================
   LIMETRE - JS customizado
   ========================================================================== */

/* --------------------------------------------------------------------------
   1) Home: banner passa por baixo do header, e o header alterna entre
      transparente (sobre o banner) e solido (branco) apos a rolagem.
   -------------------------------------------------------------------------- */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('limetre-home')) return;

  var section, wrapper, main, banner;

  function cacheElements() {
    section = document.querySelector('.section-header');
    wrapper = document.querySelector('.header-wrapper');
    main = document.getElementById('MainContent');
    banner = main ? main.firstElementChild : null;
    return !!(section && wrapper && main && banner);
  }

  /* Sobe o conteudo ate o topo visual do header, para o banner passar por
     baixo dele. A medicao e feita com o header temporariamente sem sticky,
     senao a posicao dele muda conforme a rolagem. */
  function layout() {
    var prevPosition = section.style.position;

    section.style.setProperty('position', 'static', 'important');
    main.style.removeProperty('margin-top');

    var base = parseFloat(window.getComputedStyle(main).marginTop) || 0;
    var delta = main.getBoundingClientRect().top - wrapper.getBoundingClientRect().top;

    main.style.setProperty('margin-top', base - delta + 'px', 'important');

    if (prevPosition) {
      section.style.setProperty('position', prevPosition);
    } else {
      section.style.removeProperty('position');
    }
  }

  function update() {
    var headerBottom = wrapper.getBoundingClientRect().bottom;
    var bannerBottom = banner.getBoundingClientRect().bottom;
    root.classList.toggle('limetre-header-solid', bannerBottom <= headerBottom);
  }

  function refresh() {
    layout();
    update();
  }

  function init() {
    if (!cacheElements()) return;
    refresh();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   2) Pop-up do carrinho: brinde nao abre o pop-up, a barra de compra sai de
      cena enquanto ele esta aberto, e a altura e medida na hora
   --------------------------------------------------------------------------
   a) O app de brindes (Hoppy Free Shipping) adiciona o brinde alguns segundos
      DEPOIS que o cliente adiciona a peca dele. Esse add passa pelo mesmo
      caminho do tema (product-form.js -> renderContents -> open), entao o
      pop-up subia DUAS vezes. Medido nesta loja, com um clique unico:
        1.127 ms  renderContents  HOUNDZ TEE BLACK - P    properties: {}
        4.660 ms  renderContents  PACK ADESIVOS LIMETRE   properties: { _isFreeGift: "true" }
      Quando o item vem marcado como brinde, o tema segue atualizando carrinho
      e contador, mas NAO abre o pop-up.

   b) Enquanto o pop-up esta aberto, o body ganha a classe
      lm-popup-carrinho-aberto. O CSS do snippets/cart-notification.liquid usa
      ela para descer a #barra-comprar. Quando fecha, a classe sai e a barra
      sobe de volta.

   c) Tambem ao abrir, medimos onde o pop-up cai na tela e definimos a altura
      maxima exata. Assim os botoes nunca ficam fora da area visivel, com 2 ou
      com 20 itens - so a lista de produtos rola por dentro.
      O topo e medido no .cart-notification-wrapper, e nao no pop-up: quando
      ele esta fechado fica deslocado com translateY(-100%), e a medida sairia
      errada. O wrapper fica parado (header sticky), medindo 77px em qualquer
      posicao de rolagem nesta loja.

   POR QUE A CLASSE DO BODY NAO E CONTROLADA DENTRO DE open()/close():
      O construtor do <cart-notification> do tema prende os botoes de fechar
      assim:  botao.addEventListener('click', this.close.bind(this))
      Esse bind acontece quando o elemento e criado, ANTES deste arquivo trocar
      o prototype. Resultado medido no navegador: o clique no X chamava o close
      ORIGINAL, a classe nunca saia do body e a barra de compra descia e nunca
      mais voltava.
        depois do X -> #cart-notification perdeu 'active'
                       body ainda com lm-popup-carrinho-aberto
      Por isso a classe agora segue o unico sinal confiavel: a classe 'active'
      que o proprio tema poe e tira do #cart-notification. Nao importa quem
      chamou o que - se o pop-up esta na tela, a barra esta escondida.

   Se um dia trocar de app de brindes, ajuste PROPRIEDADES_DE_BRINDE abaixo.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var PROPRIEDADES_DE_BRINDE = ['_isFreeGift', '_freeGiftGoal'];
  var ELEMENTOS = ['cart-notification', 'cart-drawer'];
  var CLASSE_CORPO = 'lm-popup-carrinho-aberto';
  var CLASSE_ABERTO = 'active';
  var FOLGA = 16;
  var ALTURA_MINIMA = 240;

  function ehItemAutomatico(estado) {
    if (!estado || !estado.properties) return false;
    for (var i = 0; i < PROPRIEDADES_DE_BRINDE.length; i++) {
      var valor = estado.properties[PROPRIEDADES_DE_BRINDE[i]];
      if (valor === undefined || valor === null) continue;
      if (valor === false || valor === 'false' || valor === '') continue;
      return true;
    }
    return false;
  }

  function popup() {
    return document.getElementById('cart-notification');
  }

  function ajustarAltura() {
    var el = popup();
    if (!el) return;
    var referencia = el.parentElement || el;
    var topo = referencia.getBoundingClientRect().top;
    var disponivel = window.innerHeight - topo - FOLGA;
    if (disponivel < ALTURA_MINIMA) disponivel = ALTURA_MINIMA;
    el.style.maxHeight = Math.round(disponivel) + 'px';
  }

  /* ---- a classe do body espelha o estado real do pop-up ------------------ */
  function vigiarPopup() {
    var el = popup();
    if (!el || el.__limetreVigiado) return;
    el.__limetreVigiado = true;

    function espelhar() {
      var aberto = el.classList.contains(CLASSE_ABERTO);
      if (aberto === document.body.classList.contains(CLASSE_CORPO)) return;
      if (aberto) ajustarAltura();
      document.body.classList.toggle(CLASSE_CORPO, aberto);
    }

    new MutationObserver(espelhar).observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });

    espelhar();
  }

  function aplicar(nome) {
    var Classe = window.customElements && customElements.get(nome);
    if (!Classe || Classe.__limetrePatchPopup) return;
    if (typeof Classe.prototype.renderContents !== 'function') return;
    if (typeof Classe.prototype.open !== 'function') return;

    Classe.__limetrePatchPopup = true;

    var renderOriginal = Classe.prototype.renderContents;
    var openOriginal = Classe.prototype.open;

    /* renderContents recebe a resposta do /cart/add.js, que traz as
       properties do item adicionado. E ele quem chama open() logo depois. */
    Classe.prototype.renderContents = function (estado) {
      this.__limetreSilenciar = ehItemAutomatico(estado);
      try {
        return renderOriginal.apply(this, arguments);
      } finally {
        this.__limetreSilenciar = false;
        /* o carrinho mudou: a barra de brindes do pop-up precisa acompanhar */
        if (window.__lmAtualizarBarraPopup) window.__lmAtualizarBarraPopup();
      }
    };

    /* open() e sempre chamado como this.open(), entao a troca no prototype
       pega. Aqui a altura ja e medida antes do pop-up aparecer; a classe do
       body fica por conta do vigia acima. */
    Classe.prototype.open = function () {
      if (this.__limetreSilenciar) return;
      ajustarAltura();
      return openOriginal.apply(this, arguments);
    };
  }

  /* Girar o celular ou abrir o teclado muda a altura util: remede enquanto
     estiver aberto. */
  var reagendar = null;
  function aoRedimensionar() {
    if (!document.body.classList.contains(CLASSE_CORPO)) return;
    clearTimeout(reagendar);
    reagendar = setTimeout(ajustarAltura, 120);
  }
  window.addEventListener('resize', aoRedimensionar);
  window.addEventListener('orientationchange', aoRedimensionar);

  /* Este arquivo carrega antes de cart-notification.js, entao esperamos o
     elemento ser definido. A chamada direta cobre o caso de ja estar pronto. */
  ELEMENTOS.forEach(function (nome) {
    aplicar(nome);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined(nome).then(function () { aplicar(nome); });
    }
  });

  vigiarPopup();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigiarPopup);
  }
})();

/* --------------------------------------------------------------------------
   3) Pagina do carrinho: etiqueta "Brinde" no preco + barra de brindes viva
   --------------------------------------------------------------------------
   a) Etiqueta preta "Brinde" ao lado do R$ 0,00, para nao restar duvida de que
      aquela linha nao esta sendo cobrada. A marcacao vem de /cart.js, onde o
      item de brinde carrega a propriedade _isFreeGift.

   b) A barra de progresso (section limetre-barra-brindes) e re-buscada quando
      o carrinho muda. O tema so re-renderiza as sections dele (cart-items,
      cart-footer), entao a nossa precisa ser atualizada aqui.

   Dois detalhes que custaram teste:
   - Como a barra vive num template JSON, o id dela vem prefixado pelo template
     (shopify-section-template--123__limetre-brindes). Por isso o id e
     descoberto no DOM em vez de ficar escrito no codigo.
   - O estado aberto/fechado NAO pode ser lido do DOM na hora de atualizar: o
     carrinho dispara varias atualizacoes seguidas e a segunda leria o painel
     ja substituido (fechado), fechando ele na cara do cliente. Por isso o
     estado fica guardado numa variavel, alimentada pelo evento toggle.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var lista = document.getElementById('main-cart-items');
  if (!lista) return;

  var observador = null;
  var agendado = null;
  var buscando = false;
  var barraAberta = false;

  /* 'toggle' nao borbulha, entao escutamos na fase de captura. */
  document.addEventListener(
    'toggle',
    function (ev) {
      var alvo = ev.target;
      if (alvo && alvo.classList && alvo.classList.contains('lm-brindes')) {
        barraAberta = alvo.hasAttribute('open');
      }
    },
    true
  );

  function elementoDaBarra() {
    return document.querySelector('[id^="shopify-section-"][id$="limetre-brindes"]');
  }

  function ehBrinde(item) {
    if (!item) return false;
    var p = item.properties;
    if (p && p._isFreeGift && p._isFreeGift !== 'false') return true;
    return item.original_line_price > 0 && item.final_line_price === 0;
  }

  function pausar() {
    if (observador) observador.disconnect();
  }

  function retomar() {
    if (observador) observador.observe(lista, { childList: true, subtree: true });
  }

  function aplicarEtiquetas(carrinho) {
    var linhas = document.querySelectorAll('#main-cart-items .cart-item');
    pausar();
    for (var i = 0; i < linhas.length; i++) {
      var linha = linhas[i];
      var deveTer = ehBrinde(carrinho.items[i]);
      var existentes = linha.querySelectorAll('.lm-tag-brinde');

      if (!deveTer) {
        for (var r = 0; r < existentes.length; r++) existentes[r].remove();
        continue;
      }
      if (existentes.length) continue;

      var celulas = linha.querySelectorAll('.cart-item__price-wrapper');
      for (var c = 0; c < celulas.length; c++) {
        var etiqueta = document.createElement('span');
        etiqueta.className = 'lm-tag-brinde';
        etiqueta.textContent = 'Brinde';
        celulas[c].appendChild(etiqueta);
      }
    }
    retomar();
  }

  function atualizarBarra() {
    var atual = elementoDaBarra();
    if (!atual || buscando) return;
    buscando = true;

    var idDaSection = atual.id.replace(/^shopify-section-/, '');

    fetch('/cart?section_id=' + encodeURIComponent(idDaSection), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.getElementById(atual.id)
          || doc.querySelector('[id^="shopify-section-"][id$="limetre-brindes"]');
        if (!novo) return;
        atual.innerHTML = novo.innerHTML;
        if (barraAberta) {
          var d = atual.querySelector('.lm-brindes');
          if (d) d.setAttribute('open', '');
        }
      })
      .catch(function () {})
      .then(function () { buscando = false; });
  }

  function sincronizar() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) { aplicarEtiquetas(carrinho); })
      .catch(function () {});
    atualizarBarra();
  }

  function agendar() {
    clearTimeout(agendado);
    agendado = setTimeout(sincronizar, 250);
  }

  observador = new MutationObserver(agendar);
  retomar();
  sincronizar();
})();

/* --------------------------------------------------------------------------
   4) Barra de brindes dentro do pop-up "Item adicionado ao carrinho"
   --------------------------------------------------------------------------
   O app de brindes desenha a barra dele (azul, so com a proxima meta) dentro
   de .cart-notification__links, no id #shipping-container-cart_drawer. Aqui a
   gente esconde aquela e coloca a nossa no lugar - a MESMA da pagina do
   carrinho, sem duplicar configuracao.

   Como a nossa barra vive numa section, da pra pedir ela renderizada pela
   Section Rendering API a partir de qualquer pagina:
       GET /cart?section_id=limetre-barra-brindes
   (o id aqui e o NOME DO ARQUIVO da section, nao a chave do templates/cart.json
   - aquela devolve 404 fora da pagina do carrinho.)

   O HTML que volta ja traz o <style> da section junto, entao a versao do
   pop-up herda o visual sem CSS duplicado. Os ajustes de tamanho ficam na
   propria section, sob .lm-brindes-popup.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SECTION = 'limetre-barra-brindes';
  var caixa = document.getElementById('lm-brindes-popup');
  if (!caixa) return;

  var buscando = false;
  var aberta = false;

  /* Some com a barra do app assim que a pagina carrega, sem esperar o fetch:
     se a nossa demorar, e melhor nao aparecer nada do que a azul do app. */
  var esconde = document.createElement('style');
  esconde.textContent =
    '#shipping-container-cart_drawer,' +
    '#shipping-container-cart_page_only,' +
    '.cart-notification .fb-shipping-bar-app { display: none !important; }';
  document.head.appendChild(esconde);

  /* 'toggle' nao borbulha: escutamos na captura para lembrar se o cliente
     deixou o painel aberto. */
  document.addEventListener(
    'toggle',
    function (ev) {
      var alvo = ev.target;
      if (alvo && alvo.classList && alvo.classList.contains('lm-brindes') && caixa.contains(alvo)) {
        aberta = alvo.hasAttribute('open');
      }
    },
    true
  );

  function atualizar() {
    if (buscando) return;
    buscando = true;

    fetch('/cart?section_id=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var secao = doc.querySelector('[id^="shopify-section-"]');
        caixa.innerHTML = secao ? secao.innerHTML : '';
        if (aberta) {
          var d = caixa.querySelector('.lm-brindes');
          if (d) d.setAttribute('open', '');
        }
      })
      .catch(function () {})
      .then(function () { buscando = false; });
  }

  /* Chamado pelo bloco 2 toda vez que o tema re-renderiza o pop-up. */
  window.__lmAtualizarBarraPopup = atualizar;

  /* Ja deixa pronta no carregamento, para o primeiro pop-up nao abrir vazio. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', atualizar);
  } else {
    atualizar();
  }
})();

/* --------------------------------------------------------------------------
   5) Pagina de produto: WhatsApp e bolha de video so na segunda metade
   --------------------------------------------------------------------------
   No topo da pagina de produto o cliente ja tem foto, preco, tamanhos, frete e
   guia de medidas para processar. Dois botoes flutuantes por cima disso e
   informacao a mais na hora errada. Da metade da pagina em diante o cenario
   muda: quem chegou ali esta decidindo, e ai a duvida no WhatsApp ou o video
   ajudam a fechar.

   O que e escondido:
     #whatsapp-widget-root #chat-bubble   -> app Dondy
     #videoBubble                          -> bolha de video do tema

   O CSS mora em assets/limetre-flutuantes.css e so vale sob .limetre-produto,
   classe que o snippets/meta-tags.liquid poe no <html> ainda no <head>. Fora
   da pagina de produto nada aqui roda.

   NAO mexemos na regra de "fechou uma vez, nao aparece mais": quem esconde de
   vez e o proprio componente da bolha. Aqui so mexemos em opacidade e clique.

   Para mudar o ponto em que aparecem, mexa em GATILHO (0.5 = metade da
   pagina). VOLTA fica um pouco abaixo de proposito: sem essa folga, parar a
   rolagem exatamente na marca faria os botoes piscarem.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GATILHO = 0.5;
  var VOLTA = 0.45;
  var CLASSE = 'lm-flutuantes-visiveis';

  var raiz = document.documentElement;
  if (!raiz.classList.contains('limetre-produto')) return;

  var pendente = false;

  function progresso() {
    var rolavel = raiz.scrollHeight - window.innerHeight;
    if (rolavel <= 0) return 1; /* pagina curta demais para rolar: mostra */
    return (window.scrollY || raiz.scrollTop || 0) / rolavel;
  }

  function avaliar() {
    pendente = false;
    var p = progresso();
    var visivel = raiz.classList.contains(CLASSE);
    if (!visivel && p >= GATILHO) {
      raiz.classList.add(CLASSE);
    } else if (visivel && p < VOLTA) {
      raiz.classList.remove(CLASSE);
    }
  }

  function agendar() {
    if (pendente) return;
    pendente = true;
    window.requestAnimationFrame(avaliar);
  }

  window.addEventListener('scroll', agendar, { passive: true });
  window.addEventListener('resize', agendar);
  window.addEventListener('load', agendar);
  agendar();
})();
